module.exports = __webpack_public_path__ + "img/inco4Ac.9de12e05.png";